module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_6.b95b73b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_6.jpg
// module id = DcF2
// module chunks = 0